"use client";

export const LoadingSpinner = ({ message = "Coach Pen is thinking..." }: { message?: string }) => (
  <div className="flex flex-col items-center justify-center gap-3 py-8">
    <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-soft border-t-[color:var(--brand-text)]" />
    <span className="text-sm font-medium text-gray-500">{message}</span>
  </div>
);
